export default __webpack_public_path__ + "static/media/inventory_iconLarge.256eaaf2.png";